import config from '../../../config';
import { showErrorMsg } from '../ErrorMsg';

export const getUserHeaderInfoUrl = `${config.api}/userHeaderInfo`;
export const getUserHeaderInfo = () =>
  $.get(getUserHeaderInfoUrl).fail((resp) => {
    const { errors = 'Error receive header' } = resp.responseJSON;
    showErrorMsg(errors);
  });



// WEBPACK FOOTER //
// ./src/Common/Providers/UserHeaderInfoApi.js